/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminAMIAccessInfo { 
    /**
     * AMI ID
     */
    ami_id?: string;
    /**
     * AMI Name
     */
    ami_name?: string;
    /**
     * AMI Owner ID
     */
    ami_owner_id?: string;
    /**
     * Creation date for the AMI
     */
    create_date?: Date;
    /**
     * Status (available/pending etc)
     */
    status?: string;
    /**
     * Public or Private AMI
     */
    visibility?: string;
    /**
     * List of Accounts in the AMI\'s accesslist
     */
    access_list?: Array<string>;
}

